import moment from "moment";
import React from "react";
import {
  Button,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  InputGroup,
  Row,
} from "react-bootstrap";
import Datetime from "react-datetime";
import FontAwesome from "react-fontawesome";
import Select from "react-select-plus";
import { Async } from "react-select-plus";
import { formatCrewName } from "../../../utils";
import CrewName from "../CrewName";
import EditCrew from "../EditCrew";
import AppointmentTypesDropDown from "../AppointmentTypesDropDown";
import CustomersDropdown from "../DropDowns/CustomersDropDown";
import DatasheetsDropdown from "../DropDowns/DatasheetsDropDown";
import JobsDropdown from "../DropDowns/JobsDropDown";
import styled from "styled-components";
import PropTypes from "prop-types";

import Timekeeper from "react-timekeeper";
import EmployeesDropdown from "../DropDowns/EmployeeDropDown";
import { searchDatasheets } from "../../../redux/searchAppointments";
import { searchCustomers } from "../../../redux/searchAppointments";
import { searchJobs } from "../../../redux/searchAppointments";
import Crew from "../../DayView/Crew";

const TimeContainer = styled.div`
  position: absolute;
  display: block;
  z-index: 2;
`;

const TimeDisplayContainer = styled.div`
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  border-radius: 2px;
  -webkit-box-shadow: 2px 2px 15px 0 rgba(0, 0, 0, 0.15);
  height: 50px;
  line-height: 50px;
  width: 260px;
`;

const TimeResetContainer = styled.div`
  text-align: center;
  font-weight: bold;
  color: #ee0303;
  font-size: 9px;
  height: 20px;
  line-height: 20px;
  width: 260px;
  cursor: pointer;
`;

const Span = styled.span`
  padding: 6px;
  margin-top: 5px;
  border: 1px solid;
  border-color: #c7bebe;
  position: absolute;
  top: -5px;
  width: 530px;
  border-radius: 0px 5px 5px 0px;
`;

const defaultCrew = {
  equipment: null,
  resources: [],
};

const transformCrewToOption = (crew) => ({
  crew,
  disabled: crew.disabled,
  label: formatCrewName(crew),
  value: crew.id,
});

const unassignedCrewOption = {
  crew: null,
  label: "Unassigned",
  value: "",
};

const getCrewOptions = (eventCrews, standardCrews) => [
  unassignedCrewOption,
  {
    label: "Event Crews",
    options: eventCrews != null ? eventCrews.map(transformCrewToOption) : "",
  },
  {
    label: "Standard Crews",
    options:
      standardCrews.size > 0 ? standardCrews.map(transformCrewToOption) : "",
  },
];

class AppointmentCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayTimepicker: false,
      startTime: props.event.startTime
        ? moment(props.event.startTime, "HH:mm:ss").format("hh:mma")
        : "",
      endTime: props.event.endTime
        ? moment(props.event.endTime, "HH:mm:ss").format("hh:mma")
        : "",
    };

    this._startTimeChecker = this.startTimeChecker.bind(this);
    this._endTimeChecker = this.endTimeChecker.bind(this);
    this._resetTime = this.resetTime.bind(this);
    this._handleCustomerChange = this.handleCustomerChange.bind(this);
    this._handleDatasheetChange = this.handleDatasheetChange.bind(this);
    this._handleJobChange = this.handleJobChange.bind(this);
  }

  /*static get propTypes() {
    return {
      event: PropTypes.object.isRequired
    };
  }*/

  componentWillReceiveProps(nextProps) {
    if (nextProps.event !== this.props.event) {
      this.setState({
        startTime: nextProps.event.startTime
          ? moment(nextProps.event.startTime, "HH:mm:ss").format("hh:mma")
          : "",
        endTime: nextProps.event.endTime
          ? moment(nextProps.event.endTime, "HH:mm:ss").format("hh:mma")
          : "",
      });
    }
  }

  toggleTimekeeper(val) {
    this.setState({ displayTimepicker: val });
  }

  resetTime(w) {
    const { onChange, event } = this.props;
    if (w === "start") {
      onChange({ event, startTime: null });
      this.setState({ startTime: "" });
    } else {
      onChange({ event, endTime: null });
      this.setState({ endTime: "" });
    }
  }

  startTimeChecker(e) {
    const { onChange, event } = this.props;

    var newStartTime = moment(e.hour + ":" + e.minute + e.meridiem, "h:mma");

    if (newStartTime.isAfter(moment(this.state.endTime, "hh:mma"))) {
      onChange({
        event,
        endTime: moment(e.hour + ":" + e.minute + e.meridiem, "h:mma").format(
          "HH:mm:ss"
        ),
      });
      this.setState({ endTime: newStartTime.format("hh:mma") });
    }
    onChange({
      event,
      startTime: moment(e.hour + ":" + e.minute + e.meridiem, "h:mma").format(
        "HH:mm:ss"
      ),
    });
    this.setState({ startTime: newStartTime.format("hh:mma") });
  }

  endTimeChecker(e) {
    const { onChange, event } = this.props;

    var newEndTime = moment(e.hour + ":" + e.minute + e.meridiem, "h:mma");

    if (newEndTime.isBefore(moment(this.state.startTime, "hh:mma"))) {
      onChange({
        event,
        startTime: moment(e.hour + ":" + e.minute + e.meridiem, "h:mma").format(
          "HH:mm:ss"
        ),
      });
      this.setState({ endTime: newEndTime.format("hh:mma") });
    }
    onChange({
      event,
      endTime: moment(e.hour + ":" + e.minute + e.meridiem, "h:mma").format(
        "HH:mm:ss"
      ),
    });
    this.setState({ endTime: newEndTime.format("hh:mma") });
  }

  // get customer ID from customer, datasheet, or job
  getEffectiveCustomerId() {
    const { event } = this.props;
    if (event.customer && event.customer.id) return event.customer.id;
    if (
      event.datasheet &&
      event.datasheet.customer &&
      event.datasheet.customer.id
    )
      return event.datasheet.customer.id;
    if (event.job && event.job.customer && event.job.customer.id)
      return event.job.customer.id;
    return null;
  }

  // clear fields when customer changes
  handleCustomerChange(customer) {
    const { onChange, event } = this.props;
    const newCustomerId = customer ? customer.id : null;
    const currentCustomerId = this.getEffectiveCustomerId();

    if (newCustomerId !== currentCustomerId) {
      onChange({ customer: customer || null, datasheet: null, job: null });
    } else {
      onChange({ customer: customer || null });
    }
  }

  // auto-populate customer from datasheet
  handleDatasheetChange(datasheet) {
    const { onChange, event } = this.props;
    const updates = { datasheet: datasheet || null };

    // If datasheet has a customer and no customer is currently selected, auto-populate
    if (datasheet && datasheet.customer && !event.customer) {
      updates.customer = datasheet.customer;
    }
    // If datasheet has a different customer, update customer and clear job
    else if (
      datasheet &&
      datasheet.customer &&
      event.customer &&
      event.customer.id !== datasheet.customer.id
    ) {
      updates.customer = datasheet.customer;
      updates.job = null;
    }

    onChange(updates);
  }

  // auto-populate customer from job
  handleJobChange(job) {
    const { onChange, event } = this.props;
    const updates = { job: job || null };

    // If job has a customer and no customer is currently selected, auto-populate
    if (job && job.customer && !event.customer) {
      updates.customer = job.customer;
    }
    // If job has a different customer, update customer and clear datasheet
    else if (
      job &&
      job.customer &&
      event.customer &&
      event.customer.id !== job.customer.id
    ) {
      updates.customer = job.customer;
      updates.datasheet = null;
    }

    onChange(updates);
  }

  render() {
    const {
      equipment,
      event,
      isApptEditCrewEnabled,
      customers,
      datasheets,
      jobs,
      onChange,
      onToggleEditCrew,
      appointmentTypes,
      resources,
      eventCrews,
      standardCrews,
      onSearchCustomers,
      onSearchDatasheets,
      onSearchJobs,
    } = this.props;

    var selected_option = appointmentTypes.filter(
      (option) => option.name === event.apptType
    );

    if (!event.appointmentType) {
      event.appointmentType = selected_option[0];
    }

    return (
      <div>
        <Row>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Start Date/Time</ControlLabel>
              <Datetime
                input={false}
                isValidDate={(value) =>
                  event.endDate ? !value.isAfter(event.endDate) : true
                }
                timeFormat={false}
                onChange={(e) =>
                  onChange({ startDate: e.format("YYYY-MM-DD") })
                }
                value={
                  event.startDate ? moment(event.startDate) : moment(Date())
                }
              />
              {this.state.displayTimepicker ? (
                <TimeContainer>
                  <Timekeeper
                    time={this.state.startTime}
                    switchToMinuteOnHourSelect={true}
                    onDoneClick={() => {
                      this.toggleTimekeeper(false);
                    }}
                    config={{
                      TIMEPICKER_BACKGROUND: "white",
                      DONE_BUTTON_COLOR: "#64c9f1",
                      DONE_BUTTON_BORDER_COLOR: "#ededed",
                    }}
                    onChange={(e) => this._startTimeChecker(e)}
                  />
                </TimeContainer>
              ) : (
                false
              )}

              <TimeDisplayContainer onClick={() => this.toggleTimekeeper(true)}>
                <FontAwesome name="clock-o" />{" "}
                {event.startTime
                  ? moment(event.startTime, "HH:mm:ss").format("hh:mma")
                  : ""}
              </TimeDisplayContainer>
              <TimeResetContainer onClick={() => this._resetTime("start")}>
                <FontAwesome name="close" /> reset
              </TimeResetContainer>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>End Date/Time</ControlLabel>
              <Datetime
                input={false}
                isValidDate={(value) =>
                  event.startDate ? !value.isBefore(event.startDate) : true
                }
                onChange={(e) => onChange({ endDate: e.format("YYYY-MM-DD") })}
                timeFormat={false}
                value={event.endDate ? moment(event.endDate) : moment(Date())}
              />
              {this.state.displayTimepicker ? (
                <TimeContainer>
                  <Timekeeper
                    time={this.state.endTime}
                    switchToMinuteOnHourSelect={true}
                    onDoneClick={() => {
                      this.toggleTimekeeper(false);
                    }}
                    config={{
                      TIMEPICKER_BACKGROUND: "white",
                      DONE_BUTTON_COLOR: "#64c9f1",
                      DONE_BUTTON_BORDER_COLOR: "#ededed",
                    }}
                    onChange={(e) => this._endTimeChecker(e)}
                  />
                </TimeContainer>
              ) : (
                false
              )}
              <TimeDisplayContainer onClick={() => this.toggleTimekeeper(true)}>
                <FontAwesome name="clock-o" />{" "}
                {event.endTime
                  ? moment(event.endTime, "HH:mm:ss").format("hh:mma")
                  : ""}
              </TimeDisplayContainer>
              <TimeResetContainer onClick={() => this._resetTime("end")}>
                <FontAwesome name="close" /> reset
              </TimeResetContainer>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FormGroup>
              <ControlLabel>Description</ControlLabel>
              <FormControl
                componentClass="textarea"
                onChange={(e) => onChange({ description: e.target.value })}
                rows={3}
                value={event.description || ""}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12} mdOffset={0}>
            <FormGroup>
              <ControlLabel>Appointment Types</ControlLabel>
              <AppointmentTypesDropDown
                clearable={false}
                appointmentTypes={appointmentTypes}
                onChange={(ap) => onChange({ appointmentType: ap || null })}
                value={event.appointmentType ? event.appointmentType.id : ""}
                valueKey="id"
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Customer</ControlLabel>
              <Select
                isLoading={customers.loading}
                labelKey="name"
                placeholder="All"
                options={customers.customers}
                defaultInputValue={event.customer ? event.customer.name : ""}
                onChange={this._handleCustomerChange}
                onInputChange={onSearchCustomers}
                onOpen={onSearchCustomers}
                loadOptions={() =>
                  searchCustomers(event.customer ? event.customer.name : "")
                }
                defaultOptions
                value={event.customer ? event.customer : ""}
                valueKey="id"
              />
            </FormGroup>

            <FormGroup>
              <ControlLabel>Datasheet</ControlLabel>
              <Select
                isLoading={datasheets.loading}
                labelKey="name"
                placeholder="All"
                autoload={true}
                defaultInputValue={event.datasheet ? event.datasheet.name : ""}
                options={datasheets.datasheets}
                onChange={this._handleDatasheetChange}
                onInputChange={(query) =>
                  onSearchDatasheets(query, this.getEffectiveCustomerId())
                }
                loadOptions={() =>
                  searchDatasheets(event.datasheet ? event.datasheet.name : "")
                }
                defaultOptions
                onOpen={() =>
                  onSearchDatasheets("", this.getEffectiveCustomerId())
                }
                value={event.datasheet ? event.datasheet : ""}
                valueKey="id"
              />
            </FormGroup>

            <FormGroup>
              <ControlLabel>Job</ControlLabel>
              <Select
                isLoading={jobs.loading}
                labelKey="name"
                placeholder="All"
                autoload={true}
                defaultInputValue={
                  event.job
                    ? `${
                        event.job.jobNumber ? event.job.jobNumber + " - " : ""
                      }${event.job.name}`
                    : ""
                }
                options={jobs.jobs}
                onChange={this._handleJobChange}
                onInputChange={(query) =>
                  onSearchJobs(query, this.getEffectiveCustomerId())
                }
                onOpen={() => onSearchJobs("", this.getEffectiveCustomerId())}
                loadOptions={() => searchJobs(event.job ? event.job.name : "")}
                defaultOptions
                value={event.job ? event.job : ""}
                valueKey="id"
              />
            </FormGroup>
          </Col>
        </Row>

        <hr />
        {isApptEditCrewEnabled ? (
          <EditCrew
            crew={event.crew || defaultCrew}
            onChange={(crew) => onChange({ crew })}
            showpercentage={false}
            equipment={equipment != null ? equipment : []}
            resources={resources != null ? resources : []}
          />
        ) : (
          <FormGroup>
            <ControlLabel>Crew</ControlLabel>
            <InputGroup>
              <InputGroup.Button>
                <Button onClick={() => onToggleEditCrew()}>
                  <FontAwesome name="pencil" />
                </Button>
              </InputGroup.Button>

              <Span>
                <CrewName crew={event.crew} />
              </Span>
            </InputGroup>
          </FormGroup>
        )}
      </div>
    );
  }
}
export default AppointmentCalendar;
